import * as ActionTypes from '../constants';
import axios from 'axios'; 
import { baseUrl } from './index';
import { getUserToken } from './getUserToken';

const dispatchRequestGetUpdateProfile = data => ({
    type: ActionTypes.REQUEST_GET_UPDATE_PROFILE,
    data
})

const dispatchReceivedGetUpdateProfile = res => ({
    type: ActionTypes.RECEIVED_GET_UPDATE_PROFILE,
    res
})

const dispatchErrorGetUpdateProfile = err => ({
    type: ActionTypes.ERROR_GET_UPDATE_PROFILE,
    err
})

const dispatchClearGetUpdateProfile = () => ({
    type: ActionTypes.CLEAR_GET_UPDATE_PROFILE
})

export const clearGetUpdateProfile = () => dispatchClearGetUpdateProfile();

export const getUpdateProfile = () => dispatch => {

    dispatch(dispatchRequestGetUpdateProfile()); 

    getUserToken()
    .then( authKey => {
        const options = {
            method: 'post',
            url: `${baseUrl}/api/user_profile`,
            headers: {
                'Authorization': `Bearer ${authKey}`
            }                   
        }
        return axios(options)
        .then(({data}) => {                         
            dispatch(dispatchReceivedGetUpdateProfile(data))
        })
    }).catch(e => dispatch(dispatchErrorGetUpdateProfile(e)));   
}
